<template>
  <div
    class="org-person-card"
    :class="{
      'org-person-card--unplaced': unplaced,
      'org-person-card--highlighted': highlighted
    }"
    role="button"
    tabindex="0"
    @click="$emit('click', person)"
    @keydown.enter="$emit('click', person)"
  >
    <div class="org-person-card__name">{{ person.name }}</div>
    <div v-if="person.title" class="org-person-card__title">{{ person.title }}</div>
    <v-chip v-if="areaLabel" x-small outlined class="org-person-card__area mt-1">
      {{ areaLabel }}
    </v-chip>
  </div>
</template>

<script>
export default {
  name: 'OrgChartPersonCard',
  props: {
    person: { type: Object, required: true },
    areaLabel: { type: String, default: '' },
    unplaced: { type: Boolean, default: false },
    highlighted: { type: Boolean, default: false }
  }
};
</script>

<style scoped>
.org-person-card {
  width: 180px;
  padding: 8px 10px;
  background: var(--pw-surface);
  border: 1px solid var(--pw-border-strong);
  border-radius: var(--pw-radius-control);
  box-shadow: var(--pw-shadow-sm);
  text-align: center;
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.org-person-card:hover,
.org-person-card:focus {
  border-color: var(--pw-primary);
  outline: none;
}

.org-person-card--unplaced {
  border-style: dashed;
  box-shadow: none;
  width: 100%;
  text-align: left;
}

.org-person-card--highlighted {
  border-color: var(--pw-primary);
  box-shadow: var(--pw-ring);
}

.org-person-card__name {
  font-weight: 600;
  color: var(--pw-text);
  line-height: 1.3;
  word-break: break-word;
}

.org-person-card__title {
  font-size: 12px;
  color: var(--pw-text-muted);
  line-height: 1.3;
  word-break: break-word;
}
</style>
